<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>

    <div class="card">
      <div class="card-header">
        <h3 v-if="mData.viewMode === 'create'">THÊM MỚI CẤP ĐẠI LÝ</h3>
        <h3 v-if="mData.viewMode === 'detail'">CHI TIẾT CẤP ĐẠI LÝ</h3>
        <h3 v-if="mData.viewMode === 'update'">CẬP NHẬT CẤP ĐẠI LÝ</h3>
      </div>

      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm">
          <b-row>
            <b-col :md="mData.viewMode == 'create' ? '6' : '6'">
              <el-form-item label="Quản lý cấp" prop="ten">
                <el-input
                  ref="ten"
                  v-model="mData.dataForm.ten"
                  :disabled="mData.viewMode === 'detail'"
                  clearable
                  @change="() => {mData.dataForm.ten = mData.dataForm.ten.trim()}"
                />
              </el-form-item>
            </b-col>
            <!-- <b-col
              md="3"
              v-if="mData.viewMode != 'create'"
              style="
                display: flex;
                align-items: flex-end;
                justify-content: center;
              "
            >
              <el-form-item style="margin-bottom: 8px" prop="hieu_luc">
                <el-checkbox
                  v-model="mData.dataForm.hieu_luc"
                  :disabled="mData.viewMode == 'detail'"
                  >Hiệu lực</el-checkbox
                >
              </el-form-item>
            </b-col> -->
            <b-col md="2" cols="6">
              <el-form-item>
                <label class="el-form-item__label w-100">Màu</label>
                <el-color-picker
                  v-model="mData.dataForm.mau"
                  :disabled="mData.viewMode == 'detail'"
                />
              </el-form-item>
            </b-col>
            <b-col md="2" cols="6">
              <el-form-item style="margin-bottom: 8px" prop="cong_khai">
                <label class="el-form-item__label w-100">Công khai</label>
                <el-checkbox
                  v-model="mData.dataForm.cong_khai"
                  :disabled="mData.viewMode == 'detail'"
                />
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-form-item>
                <label class="el-form-item__label w-100">Chiết khấu khách</label>
                <el-checkbox
                  v-model="mData.dataForm.chiet_khau_khach"
                  :disabled="mData.viewMode == 'detail'"
                />
              </el-form-item>
            </b-col>
          </b-row>
          <el-form-item label="Mô tả" prop="mo_ta">
            <el-input
              v-model="mData.dataForm.mo_ta"
              :rows="4"
              type="textarea"
              placeholder="Nhập mô tả"
              :disabled="mData.viewMode == 'detail'"
            />
          </el-form-item>
          <el-form-item label="Chiết khấu" />
          <!-- <b-row class="form-space-between"> -->
          <b-row class="list-discount">
            <b-col
              v-for="(san_pham, index) in mData.listSanPham"
              :key="san_pham.id"
              :xl="3"
              :md="4"
              :sm="6"
            >
              <el-form-item :label="san_pham.ten" style="display: flex">
                <div style="display: flex; width: 100px">
                  <el-input
                    v-model="san_pham.value"
                    @change="changeSanPham(san_pham, index)"
                    :disabled="mData.viewMode == 'detail'"
                    type="number"
                    min="0"
                    max="100"
                  ></el-input>
                  <span>&nbsp;%</span>
                </div>
              </el-form-item>
            </b-col>
          </b-row>
          <el-divider></el-divider>
          <el-form-item label="Điều kiện giảm cấp" class="mb-0" />
          <b-row>
            <b-col md="4">
              <el-form-item label="Cấp hạ xuống">
                <el-select
                  v-model="mData.dataForm.giam_cap.cap_id"
                  placeholder="Chọn cấp"
                  clearable
                  @clear="clearGiamCap"
                  @change="changeGiamCap"
                  :disabled="mData.viewMode == 'detail'"
                >
                  <el-option
                    v-for="item in mData.listCaps"
                    :key="item.id"
                    :label="item.ten"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="4" v-if="mData.dataForm.giam_cap.cap_id">
              <el-form-item label="Doanh thu 365" prop="giam_cap.dieu_kien.doanh_thu_365">
                <ElementUIMoney
                  v-model="mData.dataForm.giam_cap.dieu_kien.doanh_thu_365"
                  label=""
                  :disabled="mData.viewMode == 'detail'"
                  :outlined="true"
                  :clearable="true"
                  :refProp="'giam_cap.dieu_kien.doanh_thu_365'"
                  ref="giam_cap.dieu_kien.doanh_thu_365"
                  @input="emitGiamCapDoanhThu"
                />
              </el-form-item>
            </b-col>
            <b-col md="4" v-if="mData.dataForm.giam_cap.cap_id">
              <el-form-item label="Số đơn 365" prop="giam_cap.dieu_kien.so_don_365">
                <el-input-number
                  :disabled="mData.viewMode == 'detail'"
                  v-model="mData.dataForm.giam_cap.dieu_kien.so_don_365"
                  :controls="false"
                  :step-strictly="true"
                  ref="giam_cap.dieu_kien.so_don_365"
                />
              </el-form-item>
            </b-col>
          </b-row>
          <el-divider></el-divider>
          <el-form-item label="Điều kiện tăng cấp" class="mb-0" />
          <b-row>
            <b-col md="4">
              <el-form-item label="Cấp tăng lên">
                <el-select
                  v-model="mData.dataForm.tang_cap.cap_id"
                  placeholder="Chọn cấp"
                  clearable
                  @clear="clearTangCap"
                  @change="changeTangCap"
                  :disabled="mData.viewMode == 'detail'"
                >
                  <el-option
                    v-for="item in mData.listCaps"
                    :key="item.id"
                    :label="item.ten"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="4" v-if="mData.dataForm.tang_cap.cap_id">
              <el-form-item label="Doanh thu 365" prop="tang_cap.dieu_kien.doanh_thu_365">
                <ElementUIMoney
                  v-model="mData.dataForm.tang_cap.dieu_kien.doanh_thu_365"
                  label=""
                  :disabled="mData.viewMode == 'detail'"
                  :outlined="true"
                  :clearable="true"
                  :refProp1="'tang_cap.dieu_kien.doanh_thu_365'"
                  ref="tang_cap.dieu_kien.doanh_thu_365"
                  @input="emitTangCapDoanhThu"
                />
              </el-form-item>
            </b-col>
            <b-col md="4" v-if="mData.dataForm.tang_cap.cap_id">
              <el-form-item label="Số đơn 365" prop="tang_cap.dieu_kien.so_don_365">
                <el-input-number
                  :disabled="mData.viewMode == 'detail'"
                  v-model="mData.dataForm.tang_cap.dieu_kien.so_don_365"
                  :controls="false"
                  :step-strictly="true"
                  ref="tang_cap.dieu_kien.so_don_365"
                />
              </el-form-item>
            </b-col>
          </b-row>

          <div class="text-center mt-3">
            <el-button
              type="danger"
              plain
              @click="fn_cancel()"
              v-ladda
              v-if="mData.viewMode === 'update' || mData.viewMode === 'create'"
              >hủy</el-button
            >
            <el-button
              type="primary"
              @click="fn_addSanPham()"
              v-ladda
              v-if="mData.viewMode === 'create'"
              >thêm mới</el-button
            >
            <el-button
              type="primary"
              @click="fn_update()"
              v-ladda
              v-if="mData.viewMode === 'update'"
              >cập nhật</el-button
            >
            <el-button
              type="primary"
              @click="fn_back()"
              v-ladda
              v-if="mData.viewMode === 'detail'"
              >quay lại</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { Circle4 } from "vue-loading-spinner";
import MethodService from "@/service/MethodService";
import LanguageService from "@/service/LanguageService";
import DataForm from "@/dataForm/dataFormCapDaiLy";
import mushroom from "viettoc-api";
import ValidService from "@/service/ValidService";
import ElementUIMoney from "@/component/ElementUiMoney";
import EventBus from "@/service/EventBus";

export default {
  data() {
    return {
      loading: false,
      aLang: LanguageService.lang,
      mData: {
        viewMode: "create",
        dataForm: MethodService.copyObject(DataForm.dataForm),
        listSanPham: [],
        listChietKhau: [],
        listCaps: [],
        validForm: {
          ten: [ValidService.required],
          giam_cap: {
            dieu_kien: {
              doanh_thu_365: [],
              so_don_365: [],
            },
          },
          tang_cap: {
            dieu_kien: {
              doanh_thu_365: [],
              so_don_365: [],
            },
          },
        },
      },
      listCap: [],
      value: '',
      options: [
        {
          value: 'Option1',
          label: 'Option1',
        },
        {
          value: 'Option2',
          label: 'Option2',
        },
        {
          value: 'Option3',
          label: 'Option3',
        },
        {
          value: 'Option4',
          label: 'Option4',
        },
        {
          value: 'Option5',
          label: 'Option5',
        },
      ]
    };
  },
  components: {
    Circle4,
    ElementUIMoney,
  },
  methods: {
    emitGiamCapDoanhThu(data) {
      this.mData.dataForm.giam_cap.dieu_kien.doanh_thu_365 = data
        ? parseInt(data)
        : undefined;
    },
    emitTangCapDoanhThu(data) {
      this.mData.dataForm.tang_cap.dieu_kien.doanh_thu_365 = data
        ? parseInt(data)
        : undefined;
    },
    // Lấy danh sách cáp
    async getDanhSachCap() {
      try {
        const agtCapRes = await mushroom.agt_cap.listAsync({
          fields: "id,ten",
        });
        console.log("Các agt_cap thỏa mãn: %o", agtCapRes.result);
        if (this.mData.viewMode == "update") {
          this.mData.listCaps = agtCapRes.result.filter(
            (e) => e.id != this.$router.currentRoute.params.id
          );
        } else {
          this.mData.listCaps = agtCapRes.result;
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    // cấp đại lý theo id
    async getCapDaiLyId() {
      try {
        const response = await mushroom.agt_cap.findByIdAsync({
          id: this.$router.currentRoute.params.id,
        });
        console.log("Thông tin agt_cap trả về: %o", response);
        if (!response.result.giam_cap)
          response.result.giam_cap = { dieu_kien: {} };
        if (!response.result.tang_cap)
          response.result.tang_cap = { dieu_kien: {} };
        this.mData.dataForm = response.result;
        this.mData.listSanPham.forEach((item) => {
          if (
            response.result.chiet_khau.find(
              (cap) => cap.san_pham_id === item.id
            )
          ) {
            item.value = response.result.chiet_khau.find(
              (cap) => cap.san_pham_id === item.id
            ).gia_tri;
          }
        });
        this.mData.listChietKhau = response.result.chiet_khau;
        console.log(
          "danh sách this.mData.listSanPham: ",
          this.mData.listSanPham
        );
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    // lấy danh sách cấp
    async getListCap() {
      try {
          const response = await mushroom.agt_cap.listAsync();
          console.log("Các agt_cap thỏa mãn: %o", response);
          if(!response.result) return;
          this.listCap = response.result
      }
      catch (e) {
          console.error("Có lỗi: %o", e);
      }
    },
    // list sản phẩm
    async getSanPham() {
      try {
        const response = await mushroom.prd_san_pham.getAllAsync({
          filters: ["dai_ly_ban=true", "hieu_luc=true"],
          limit: 100,
        });
        let resData = await this.fn_changeDataSanPham(response.result);
        this.mData.listSanPham = resData;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    // custom sản phầm
    fn_changeDataSanPham(data) {
      data.forEach((item) => {
        item.value = undefined;
      });
      return data;
    },
    changeSanPham(san_pham, index) {
      if (san_pham.value < 0 || san_pham.value > 100) {
        this.mData.listSanPham.forEach((item) => {
          if (item.id === san_pham.id) {
            if (san_pham.value < 0) {
              item.value = 0;
            } else if (san_pham.value > 100) {
              item.value = 100;
            }
          }
        });
      }
      const listChietKhauNew = JSON.parse(
        JSON.stringify(this.mData.listChietKhau)
      );

      if (this.mData.listChietKhau.length > 0) {
        this.mData.listChietKhau.forEach((item, index) => {
          if (item.san_pham_id === san_pham.id) {
            console.log("xóa trùng");
            listChietKhauNew.splice(index, 1);
          }
        });
      }
      if (san_pham.value && san_pham.value.length > 0) {
        console.log("thêm");
        listChietKhauNew.push({
          san_pham_id: san_pham.id,
          gia_tri: san_pham.value,
        });
      }
      this.mData.listChietKhau = JSON.parse(JSON.stringify(listChietKhauNew));
      console.log("danh sách chiết khấu: ", this.mData.listChietKhau);
    },
    // reset form
    fn_resetForm() {
      this.$refs.myForm.$el.reset();
    },
    fn_resetDataForm() {
      this.mData.dataForm.ten = undefined;
      this.mData.dataForm.mo_ta = undefined;
      this.mData.dataForm.chiet_khau = [];
      this.mData.dataForm.hieu_luc = false;
    },
    fn_cancel() {
      this.fn_resetForm();
      this.fn_resetDataForm();
      this.$router.go(-1);
    },
    focusInputError(objectError) {
      const arrKeyObject = Object.keys(objectError)
      if (arrKeyObject.length == 0) return
      if (arrKeyObject[0] === 'tang_cap.dieu_kien.doanh_thu_365' || arrKeyObject[0] === 'giam_cap.dieu_kien.doanh_thu_365') {
        EventBus.$emit(`focusInput_${arrKeyObject[0]}`, {field: arrKeyObject[0]})
        return
      }
      this.$refs[arrKeyObject[0]].focus()
    },
    // thêm mới
    async fn_addSanPham() {
      this.$refs["myForm"].validate(async (valid, object) => {
        this.focusInputError(object)
        if (valid) {
          const agt_cap_object = this.mData.dataForm;
          agt_cap_object.chiet_khau = this.mData.listChietKhau;
          console.log("dữ liệu gửi lên: ", agt_cap_object);
          // return
          if (this.mData.dataForm.ten == undefined) {
            window.toastr.warning("Cần nhập tên cấp đại lý");
            MethodService.stopLadda();
          } else {
            try {
              const newId = await mushroom.agt_cap.createAsync(agt_cap_object);
              console.log("Thêm mới thành công, new id: %o", newId);
              window.toastr.success("Thêm mới cấp đại lý thành công");
              // this.$router.push({
              //   name: "DanhSachCapDaiLy",
              // });
              this.fn_back()
            } catch (error) {
              console.error("Có lỗi: %o", error);
              if (error.code === 4) {
                window.toastr.error(this.aLang.no_server);
              } else if (error.code === 2) {
                window.toastr.error("Gặp sự cố tải dữ liệu");
              } else {
                window.toastr.error("Đã có lỗi xảy ra");
              }
              MethodService.stopLadda();
            }
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    // cập nhật
    async fn_update() {
      // const agt_cap_object = {
      //   id: this.$router.currentRoute.params.id,
      //   ten: this.mData.dataForm.ten,
      //   mo_ta: this.mData.dataForm.mo_ta,
      //   chiet_khau: this.mData.listChietKhau,
      //   enabled: this.mData.dataForm.enabled,
      // };
      this.$refs["myForm"].validate(async (valid, object) => {
        this.focusInputError(object)
        if (valid) {
          const agt_cap_object = this.mData.dataForm;
          agt_cap_object.chiet_khau = this.mData.listChietKhau;
          console.log("dữ liệu update cấp: ", agt_cap_object);
          if (this.mData.dataForm.ten == undefined) {
            window.toastr.warning("Cần nhập tên cấp đại lý");
            MethodService.stopLadda();
          } else {
            try {
              const response = await mushroom.agt_cap.partialUpdateAsync(
                agt_cap_object
              );
              if (response.result == this.$router.currentRoute.params.id) {
                window.toastr.success("Cập nhật cấp đại lý thành công");
                // this.$router.push({
                //   name: "DanhSachCapDaiLy",
                // });
                this.fn_back()
              } else {
                window.toastr.warning("Dữ liệu không thay đổi");
                MethodService.stopLadda();
              }
            } catch (error) {
              console.error("Có lỗi: %o", error);
              if (error.code === 4) {
                window.toastr.error(this.aLang.no_server);
              } else if (error.code === 2) {
                window.toastr.error("Máy chủ không phản hồi");
              } else window.toastr.error("Đã có lỗi xảy ra");
              MethodService.stopLadda();
            }
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    // quay lại
    fn_back() {
      this.$router.go(-1);
    },
    checkDoanhThuGiamCap(rule, value, callback) {
      if (this.mData.dataForm.tang_cap.dieu_kien.doanh_thu_365 === undefined || this.mData.dataForm.tang_cap.dieu_kien.doanh_thu_365 === null) {
        callback()
      } else if (value >= this.mData.dataForm.tang_cap.dieu_kien.doanh_thu_365) {
        callback(new Error('Doanh thu 365 giảm cấp phải nhỏ hơn doanh thu 365 tăng cấp'))
      } else {
        callback()
      }
    },
    checkSoDonGiamCap(rule, value, callback) {
      if (this.mData.dataForm.tang_cap.dieu_kien.so_don_365 === undefined || this.mData.dataForm.tang_cap.dieu_kien.so_don_365 === null) {
        callback()
      } else if (value >= this.mData.dataForm.tang_cap.dieu_kien.so_don_365) {
        callback(new Error('Số đơn 365 giảm cấp phải nhỏ hơn số đơn 365 tăng cấp'))
      } else {
        callback()
      }
    },
    checkDoanhThuTangCap(rule, value, callback) {
      if (this.mData.dataForm.giam_cap.dieu_kien.doanh_thu_365 === undefined || this.mData.dataForm.giam_cap.dieu_kien.doanh_thu_365 === null) {
        callback()
      } else if (value <= this.mData.dataForm.giam_cap.dieu_kien.doanh_thu_365) {
        callback(new Error('Doanh thu 365 tăng cấp phải lớn hơn doanh thu 365 giảm cấp'))
      } else {
        callback()
      }
    },
    checkSoDonTangCap(rule, value, callback) {
      if (this.mData.dataForm.giam_cap.dieu_kien.so_don_365 === undefined || this.mData.dataForm.giam_cap.dieu_kien.so_don_365 === null) {
        callback()
      } else if (value <= this.mData.dataForm.giam_cap.dieu_kien.so_don_365) {
        callback(new Error('Số đơn 365 tăng cấp phải lớn hơn số đơn 365 giảm cấp'))
      } else {
        callback()
      }
    },
    changeGiamCap() {
      this.mData.validForm.giam_cap = {
        dieu_kien: {
          doanh_thu_365: [ValidService.required, { validator: this.checkDoanhThuGiamCap, trigger: ['change', 'blur'] }],
          so_don_365: [ValidService.required, { validator: this.checkSoDonGiamCap, trigger: ['change', 'blur'] }],
        },
      }
    },
    clearGiamCap() {
      this.mData.dataForm.giam_cap.dieu_kien.doanh_thu_365 = undefined;
      this.mData.dataForm.giam_cap.dieu_kien.so_don_365 = undefined;
    },
    clearTangCap() {
      this.mData.dataForm.tang_cap.dieu_kien.doanh_thu_365 = undefined;
      this.mData.dataForm.tang_cap.dieu_kien.so_don_365 = undefined;
    },
    changeTangCap() {
      this.mData.validForm.tang_cap = {
        dieu_kien: {
          doanh_thu_365: [ValidService.required, { validator: this.checkDoanhThuTangCap, trigger: ['change', 'blur'] }],
          so_don_365: [ValidService.required, { validator: this.checkSoDonTangCap, trigger: ['change', 'blur'] }],
        },
      }
    },
  },

  async created() {
    if (this.$router.currentRoute.name == "TaoCapDaiLy") {
      this.mData.viewMode = "create";
      this.loading = false;
    }
    if (this.$router.currentRoute.name == "CapDaiLyChiTiet") {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.name == "CapNhatCapDaiLy") {
      this.mData.viewMode = "update";
    }
    await this.getSanPham();
    await this.getDanhSachCap();
    // kiểm tra loại viewMode
    console.log(this.$router.currentRoute.name);
    if (this.mData.viewMode == "update" || this.mData.viewMode == "detail")
      await this.getCapDaiLyId();
  },
};
</script>
<style lang="scss" scoped>
// .form-space-between {
//   display: flex;
//   justify-content: flex-start;
// }
::v-deep .el-divider--horizontal {
  margin: 5px 0 10px 0;
}
::v-deep .el-form-item__label {
  white-space: break-spaces;
  min-width: 225px;
}
@media (min-width: 1560px) {
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
}
@media (min-width: 1234px) and (max-width: 1560px) {
  .col-xl-3 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }
}
@media (min-width: 768px) and (max-width: 1233px) {
  .col-xl-3 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media (min-width: 320px) and (max-width: 710px) {
  .col-xl-3 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  ::v-deep .el-form-item__label {
    white-space: nowrap;
    min-width: 230px;
  }
}
</style>
